import { render, staticRenderFns } from "./Movie24hPaymentSuccess.vue?vue&type=template&id=6c3f6b1e&scoped=true&"
import script from "./Movie24hPaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./Movie24hPaymentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./Movie24hPaymentSuccess.vue?vue&type=style&index=0&id=6c3f6b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3f6b1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
